export { default } from "bullitttime-embermodelsevent/adapters/event";
